// @flow
import BaseComponent from '../../base_component/base_component'

export default class Tile extends BaseComponent {
    initialize() {
        $.getJSON(this.options.controller, this.initTiles.bind(this));
    }

    initTiles(data) {
        this.find('.tile-spinner').hide();

        if (data.length === 0) {
            return $('.no-content-message').removeAttr('hidden');
        }
        let tiles = this.find('.tile');

        data.forEach((element, i) => {
            this.setTileContent($(tiles[i]), element);
        });
    }

    setTileContent(tile, element) {
        tile.css('visibility', 'visible');
        tile.find('.title').html(element.title);
        tile.find('.description').html(element.description);
        if (element.thumbnail_url) {
            tile.find('.title-thumbnail').css(
                'background-image', `url(${element.thumbnail_url})`);
            tile.find('.hidden-image').attr('src', element.thumbnail_url);
        }
    }
}